import React from "react";
import {
  Edit,
  ReferenceInput,
  TextInput,
  translate,
  LongTextInput,
  ImageField,
  TextField,
  TabbedForm,
  FormTab,
  BooleanField,
  BooleanInput,
  SelectInput,
  ReferenceField
} from "admin-on-rest";
import {GET_ONE} from "admin-on-rest";
import {validatePromo, validatePartnerName, validateVoucherCode, validateMarketingPartnerID, validateCampaignID} from "./validations";
import {formStyle} from "./style";
import AutoComplete from "material-ui/AutoComplete";
import DateInput from "../../../components/DateInput";
import ImageInput from "../../../components/CRM/ImageInput";
import {connect} from "react-redux";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import RichTextInput from "aor-rich-text-input";
import RaisedButton from "material-ui/RaisedButton";
import restClient from "../../../restClient";
import {UPDATE} from "admin-on-rest";
import CircularProgress from "material-ui/CircularProgress";
import {
  showNotification as showNotificationAction,
  refreshView as refreshViewAction
} from "admin-on-rest";
import SelectArrayInput from "../../../admin-on-rest/src/mui/input/SelectArrayInput";
import ReferenceArrayInput from "../../../admin-on-rest/src/mui/input/ReferenceArrayInput";
import ReferenceSelectGrid from "../../../components/ReferenceSelectGrid";
import ReferenceArrayInput2 from "../../../components/ReferenceArrayInput2";
import StoreFilter from "../Stores/StoreFilter";
import ActionBar from "../../../components/CRM/ActionBar/";
import VoucherCodeInput from "../../../components/VoucherCodeInputGenerate";
import Interpolations from "../../../components/Interpolations";

const PromoTitleBase = ({record, translate}) => {
  return (
    <span style={formStyle.titleStyle}>
      {translate("resources.promos.titleEdit")}{" "}
      {record ? `  ${record.name}` : ""}
    </span>
  );
};

const PromoTitle = translate(PromoTitleBase);

const InputHeaderBase = ({translate, header, headerStyle}) => (
  <div style={headerStyle}>
    <span>{translate(header)}:</span>
  </div>
);

const InputHeader = translate(InputHeaderBase);

class PromoEditForm extends React.Component {
  constructor(props) {
    super(props)
  
    this.state = {
      externalLink: true,
      tos: true,
      isLoading: false,
      marketingPartnerValue: ''
    }
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    if (this.props.configuration && this.props.configuration.promos) {
      const {history} = this.props;
      if (this.props.configuration.promos.enabled !== true)
        history.replace(`/`);
    }
    if (this.props.record) {
      if (this.props.record.external_link === null) {
        this.setState({externalLink: false});
      } else {
        this.setState({externalLink: true});
      }
      if (
        this.props.record.tos === null ||
        this.props.record.tos === "<p><br></p>"
      ) {
        this.setState({tos: false});
      } else {
        this.setState({tos: true});
      }
    }
  }

  componentDidUpdate(nextProps) {
    const { selected_marketing_id, marketing_id} = this.state;

    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.promos.enabled !== true)
        history.replace(`/`);
    }

    if(!this.state.marketingPartnerValue && this.props.record) {
      return restClient(GET_ONE, "marketing_partners", {id: this.props.record.marketing_partner_id})
        .then(marketingPartner => {
          return this.setState({
            marketingPartnerValue: marketingPartner.data.name, 
            marketing_id: marketingPartner.data.id
          })
      })
    }

    if (selected_marketing_id && marketing_id !== selected_marketing_id) {
      return restClient(GET_ONE, "marketing_partners", {id: selected_marketing_id}).then(marketingPartner => {
        return this.setState({
          marketingPartnerValue: marketingPartner.data.name, 
          marketing_id: marketingPartner.data.id
        })
      })
    }
  }

  handleChange(e, value) {
    this.setState({selected_marketing_id : value});
  }

  handleExternalLinkToggle = () => {
    if (this.state.externalLink) {
      this.setState({externalLink: false});
    } else {
      this.setState({externalLink: true});
    }
  };

  handleTosToggle = () => {
    if (this.state.tos) {
      this.setState({tos: false});
    } else {
      this.setState({tos: true});
    }
  };

  handleActivationButton = () => {
    const {showNotification} = this.props;
    this.setState({isLoading: true});
    const promoId = this.props.record.id;
    const promoData = this.props.record.active ? false : true;
    const previousPromoData = this.props.record.active ? true : false;

    restClient(UPDATE, "promos", {
      id: promoId,
      data: {active: promoData},
      previousData: {active: previousPromoData}
    })
      .then(() => {
        this.setState({isLoading: false});
        showNotification("aor.notification.updated");
        this.props.refreshView();
      })

      .catch(error => {
        showNotification(error.message, "warning");
      });
  };

  render() {
    const props = {...this.props};
    const reduxErrors = {...props.errors};
    const errors = {...reduxErrors.syncErrors};
    const {isLoading, marketingPartnerValue} = this.state;
    const {record, translate} = props;

    const interpolations = [
      [".SignupURL"],
      [".Customer.FirstName", ".Customer.LastName", ".Customer.Phone", ".Customer.Email"],
      [".Owner.FirstName", ".Owner.LastName", ".Owner.Email"],
      [".Store.Name", ".Store.SMSSender"]
    ];

    return (
      <Edit title={<PromoTitle />} {...props}>
        <TabbedForm redirect="list" validate={validatePromo}>
          <FormTab
            label="resources.promos.titleTab1"
            elStyle={formStyle.tabStyle}
          >
            <TextInput
              label="resources.promos.inputs.promoName"
              source="name"
            />
            <DateInput
              label="resources.promos.inputs.validFrom"
              source="valid_from"
              locale="sv"
              hideCalendarDate={true}
              showIcon={false}
              isDesktop={true}
              wrapperStyle={formStyle.inputStyle.dateInput}
            />
            <DateInput
              label="resources.promos.inputs.validTo"
              source="valid_to"
              locale="sv"
              hideCalendarDate={true}
              isDesktop={true}
              showIcon={false}
              removeDate={true}
              wrapperStyle={formStyle.dateStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <ReferenceArrayInput
              style={formStyle.tabStyle}
              label="resources.promos.inputs.industry"
              source="industry_ids"
              reference="industries"
              sort={{field: "name", order: "ASC"}}
              allowEmpty={false}
            >
              <SelectArrayInput
                optionText="name"
                possibleValues={this.props.industries}
              />
            </ReferenceArrayInput>
            <ReferenceInput
              label="resources.promos.inputs.marketingPartner"
              source="marketing_partner_id"
              reference="marketing_partners"
              validate={validatePartnerName}
              sort={{field: "name", order: "ASC"}}
              perPage={50}
              allowEmpty={false}
              style={formStyle.labelStyle}
              onChange={this.handleChange}
            >
              <AutocompleteInput
                optionText={record => `${record.name}`}
                options={{filter: AutoComplete.caseInsensitiveFilter}}
              />
            </ReferenceInput>

            <div style={formStyle.clearFloatContainer} />

            <SelectInput allowEmpty={true} label="resources.promos.inputs.category.label" source="category" choices={[
                { id: 'sports', name: 'resources.promos.inputs.category.choices.sports' },
                { id: 'casino', name: 'resources.promos.inputs.category.choices.casino' },
            ]}/>

            <TextInput
              label="resources.promos.inputs.title"
              source="title"
              style={formStyle.inputStyle}
            />

            <LongTextInput
              label="resources.promos.inputs.description"
              source="text"
              style={formStyle.inputStyle}
            />

            <ImageInput
              {...props}
              source="images.large"
              label={translate("resources.promos.inputs.image", {
                dimensions: this.props.imageLabel.large
              })}
              accept="image/*"
              validWidth={this.props.dimensions.large.imageWidth}
              validHeight={this.props.dimensions.large.imageHeight}
              style={formStyle.labelStyle}
            >
              <ImageField source="src" title="title" />
            </ImageInput>

            <ImageInput
              {...props}
              source="images.small"
              label={translate("resources.promos.inputs.smallImage", {
                dimensions: this.props.imageLabel.small
              })}
              accept="image/*"
              validWidth={this.props.dimensions.small.imageWidth}
              validHeight={this.props.dimensions.small.imageHeight}
              style={formStyle.labelStyle}
            >
              <ImageField source="src" title="title" />
            </ImageInput>

            <div style={formStyle.clearFloatContainer} />

            <LongTextInput
              label="resources.promos.inputs.localPageText"
              source="local_page_text"
              style={formStyle.inputStyle}
            />

            <TextInput
              label="resources.promos.inputs.externalLink"
              source="external_link"
            />

            <BooleanInput
              label="resources.promos.inputs.displayOnTablet"
              source="display_on_tablet"
              style={formStyle.inputStyle.booleanInput}
              defaultValue
            />
            <BooleanInput
              label="resources.promos.inputs.displayOnWeb"
              source="display_on_web"
              style={formStyle.inputStyle.booleanInput}
              defaultValue
            />

            <VoucherCodeInput
              label="resources.promos.inputs.voucherCode"
              source="voucher_code" 
              validate={validateVoucherCode}
              style={formStyle.voucherStyle}
            />
            <div style={formStyle.clearFloatContainer} />

            <RichTextInput
              label="resources.promos.inputs.tosText"
              source="tos"
              style={formStyle.richText}
            />
            {this.state.tos && (reduxErrors.submitFailed && errors.tos) && (
              <span style={formStyle.validationStyle}>
                {translate("resources.promos.validation.requiredTosText")}
              </span>
            )}
            <div style={formStyle.activateButton}>
              <RaisedButton
                label={
                  isLoading === true ? (
                    <CircularProgress
                      size={25}
                      thickness={2}
                      color="#fff"
                      style={formStyle.raisedButtonProgress}
                    />
                  ) : (
                    <span style={formStyle.raisedButtonLabel}>
                      {record && record.active
                        ? translate("resources.promos.inputs.deactivate")
                        : translate("resources.promos.inputs.activate")}
                    </span>
                  )
                }
                onClick={this.handleActivationButton}
                primary={record && !record.active}
                secondary={record && record.active}
                style={formStyle.raisedButton}
                labelColor="#fff"
              />
            </div>
          </FormTab>
          <FormTab label="resources.promos.titleTab2">
            <ReferenceArrayInput2
              perPage={60}
              source="kiosk_ids"
              reference="kiosks"
              location={props.location}
              actions={
                <ActionBar
                  createButton={false}
                  deleteButton={false}
                  withActionMenu={false}
                />
              }
              filters={<StoreFilter isNested={true} />}
            >
              <ReferenceSelectGrid
                options={{
                  multiSelectable: true,
                  selectable: true
                }}
                headerOptions={{
                  adjustForCheckbox: true,
                  displaySelectAll: true,
                  enableSelectAll: true
                }}
                bodyOptions={{
                  displayRowCheckbox: true,
                  deselectOnClickaway: false,
                  showRowHover: true
                }}
                rowOptions={{selectable: true}}
              >
                <TextField
                  label="resources.stores.fields.storeName"
                  source="name"
                />
                <TextField
                  label="resources.stores.fields.email"
                  source="email"
                />
                <ReferenceField label="resources.stores.fields.region" source="region_id" reference="regions">
                  <TextField source="name" />
                </ReferenceField>
                <TextField
                  label="resources.stores.fields.deviceSerialNumber"
                  source="device_serial_number"
                />
                <BooleanField
                  label="resources.stores.fields.active"
                  source="active"
                />
              </ReferenceSelectGrid>
            </ReferenceArrayInput2>
          </FormTab>
          <FormTab
            label="resources.welcomeMessage.name"
            elStyle={formStyle.tabStyle}
          >
            <TextInput
              label="resources.welcomeMessage.inputs.smsFrom"
              source="sms_from"
            />
            <LongTextInput
              label="resources.welcomeMessage.inputs.smsText"
              source="sms_text"
              style={formStyle.inputStyle.lastInput}
            />

            <Interpolations interpolations={interpolations}/>

          </FormTab>
          <FormTab
            label="resources.promos.titleTab4"
            elStyle={formStyle.tabStyle}
          >
            { marketingPartnerValue !== 'mrgreen'
            && marketingPartnerValue !== 'william_hill'
            && marketingPartnerValue !== 'betfair'
            && marketingPartnerValue !== 'cashbacker'
            && marketingPartnerValue !== 'storemarket'
            && <InputHeader
                header="resources.promos.selectToSeeExtraTab"
                style={{margin: "10px"}}                
              />}

            {marketingPartnerValue === 'mrgreen' &&
              <FormTab
                label="resources.promos.titleTab4"
                elStyle={formStyle.tabStyle}
              >
                <div style={formStyle.clearFloatContainer} />
                <InputHeader
                  header="resources.promos.inputs.marketingPartnerTab.mrGreen.name"
                  headerStyle={formStyle.headerContainer}
                  style={formStyle.headerSectionStyle}
                />
                <div style={formStyle.clearFloatContainer} />
                <TextInput
                  label="resources.promos.inputs.marketingPartnerTab.mrGreen.lpid"
                  source="extra.mrgreen.lpid"
                  validate={validateMarketingPartnerID}
                />
                <TextInput
                  label="resources.promos.inputs.marketingPartnerTab.mrGreen.bid"
                  source="extra.mrgreen.bid"
                  validate={validateMarketingPartnerID}
                />
                <div style={formStyle.clearFloatContainer} /> 
              </FormTab>}

            {marketingPartnerValue === 'william_hill' &&
            <FormTab
                label="resources.promos.titleTab4"
                elStyle={formStyle.tabStyle}
            >
              <div style={formStyle.clearFloatContainer} />
              <InputHeader
                  header="resources.promos.inputs.marketingPartnerTab.william_hill.name"
                  headerStyle={formStyle.headerContainer}
                  style={formStyle.headerSectionStyle}
              />
              <div style={formStyle.clearFloatContainer} />
              <TextInput
                  label="resources.promos.inputs.marketingPartnerTab.william_hill.bid"
                  source="extra.william_hill.bid"
                  validate={validateMarketingPartnerID}
              />
              <div style={formStyle.clearFloatContainer} />
            </FormTab>}

            {marketingPartnerValue === 'betfair' &&
            <FormTab
                label="resources.promos.titleTab4"
                elStyle={formStyle.tabStyle}
            >
              <div style={formStyle.clearFloatContainer} />
              <InputHeader
                  header="resources.promos.inputs.marketingPartnerTab.betfair.name"
                  headerStyle={formStyle.headerContainer}
                  style={formStyle.headerSectionStyle}
              />
              <div style={formStyle.clearFloatContainer} />
              <TextInput
                  label="resources.promos.inputs.marketingPartnerTab.betfair.bid"
                  source="extra.betfair.bid"
              />
              <div style={formStyle.clearFloatContainer} />
            </FormTab>}

            {marketingPartnerValue === 'cashbacker' &&
              <FormTab
                label="resources.promos.titleTab4"
                elStyle={formStyle.tabStyle}
              >
                <div style={formStyle.clearFloatContainer} />
                <InputHeader
                    header="resources.promos.inputs.marketingPartnerTab.cashbacker.name"
                    headerStyle={formStyle.headerContainer}
                    style={formStyle.headerSectionStyle}
                />
                <div style={formStyle.clearFloatContainer} />
                <TextInput
                  label="resources.promos.inputs.marketingPartnerTab.cashbacker.campaign_id"
                  source="extra.cashbacker.campaign_id"
                  validate={validateCampaignID}
                />
                <BooleanInput
                  label="resources.promos.inputs.giftcard"
                  source="extra.cashbacker.gift_card_enabled"
                  defaultValue
                  style={formStyle.inputStyle.booleanInput}
                />
                <div style={formStyle.clearFloatContainer} /> 
              </FormTab>}



            {marketingPartnerValue === 'storemarket' &&
            <FormTab
                label="resources.promos.titleTab4"
                elStyle={formStyle.tabStyle}
            >
              <div style={formStyle.clearFloatContainer} />
              <InputHeader
                  header="resources.promos.inputs.marketingPartnerTab.storemarket.name"
                  headerStyle={formStyle.headerContainer}
                  style={formStyle.headerSectionStyle}
              />
              <div style={formStyle.clearFloatContainer} />
              <BooleanInput
                  label="resources.promos.inputs.giftcard"
                  source="extra.storemarket.gift_card_enabled"
                  defaultValue
                  style={formStyle.inputStyle.booleanInput}
              />
              <div style={formStyle.clearFloatContainer} />
            </FormTab>}


          </FormTab>
        </TabbedForm>
      </Edit>
    );
  }
}

const mapStateToProps = (state, props) => ({
  isLoading: state.admin.loading > 0,
  errors: state.form[`record-form`],
  configuration: state.configuration,
  id: decodeURIComponent(props.match.params.id),
  record: state.admin.resources[props.resource]
    ? state.admin.resources[props.resource].data[
        decodeURIComponent(props.match.params.id)
      ]
    : null,
  industries: state.admin.resources.industries
});

const mapDispatchToProps = {
  showNotification: showNotificationAction,
  refreshView: refreshViewAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate(PromoEditForm));



// WEBPACK FOOTER //
// ./src/containers/CRM/Promos/PromoEditForm.js